import { customInstance } from 'lib/api-instance'

export type SchoolOnboardingEligibility = {
  eligible: boolean
}

type ResponseSuccess<T> = {
  data: T
  status: number
  headers: Headers
}

export const getSchoolOnboardingEligibility = async (
  options?: RequestInit
): Promise<ResponseSuccess<SchoolOnboardingEligibility>> => {
  return customInstance<ResponseSuccess<SchoolOnboardingEligibility>>(
    '/api-arvore/school-onboarding/me',
    {
      ...options,
      method: 'GET'
    }
  )
}
